import React from 'react';

import { Skeleton } from 'fpay-ui';
import styled from 'styled-components';

const Card = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 8px;
  font-size: 12px;
  > div {
    align-items: center;
  }

  > div:first-child {
    display: flex;
    padding-bottom: 8px;
    font-size: 14px;
    > div {
      padding: 0px;
    }
    div:first-child {
      flex-grow: 1;
    }
    div:nth-child(2) {
      padding-right: 12px;
      color: #a2a7ba;
    }
  }

  > div:nth-child(2) {
    color: #a2a7ba;
  }

  > div:nth-child(3) {
    display: flex;
    padding-top: 4px;
    > div {
      padding: 0px;
    }
    div:first-child {
      flex-grow: 1;
    }
  }
`;

const StyledSkeleton = styled(Skeleton)`
  height: 16px;
  ${({ width }) => width && `width: ${width}px`}
`;

export const SkeletonLoader = () => (
  <>
    {[...Array(6)].map((_, i) => (
      <Card key={i}>
        <div>
          <div>
            <StyledSkeleton width={41} />
          </div>
          <div />
          <div>
            <StyledSkeleton width={76} />
          </div>
        </div>
        <div>
          <StyledSkeleton width={99} />
        </div>
        <div>
          <div>
            <StyledSkeleton width={71} />
          </div>
          <StyledSkeleton width={68} />
        </div>
      </Card>
    ))}
  </>
);
